import React, { useEffect, useState } from "react";
import { HStack, Heading } from "@chakra-ui/react";
import { DateTime } from "luxon";

const Clock = () => {
  const [now, setNow] = useState(DateTime.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(DateTime.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <HStack>
      <Heading size="3xl" textAlign="center" color="gray.500">
        {now.toFormat("h:mm a")}
      </Heading>
    </HStack>
  );
};

export default Clock;
